export function ColorDot({ color }: { color: string | null }) {
  if (!color) return <div className="w-3 h-3 rounded-full bg-muted-foreground/40" />
  return <div className="w-3 h-3 rounded-full" style={{ backgroundColor: color }} />
}
